import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { appConfig } from '../app.config';
import { StyleLoadGuard } from '../core/style-load-guard/style-load.guard';
import { StyleBundle } from '../shared/enum/style-bundle.enum';
import { RegretPageComponent } from './regret-page/regret-page.component';

const routes: Routes = [
  {
    path: ':shopUid/products/:aliasCode',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.PDP_BUNDLE },
    loadChildren: () => import('../pdp-page/pdp-page.module').then(m => m.PdpPageModule)
  },
  {
    path: ':shopUid/checkout',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.CART_BUNDLE },
    loadChildren: () => import('../cart/cart.module').then(m => {
      m.CartModule.forRoot(appConfig.cartConfig);
      return m.CartModule;
    })
  },
  {
    path: ':shopUid/checkout/registration',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.REGISTRATION_BUNDLE },
    loadChildren: () => import('../registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: ':shopUid/confirmation',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.ORDER_CONFIRMATION_BUNDLE },
    loadChildren: () => import('../order-confirmation/order-confirmation.module').then(m => m.OrderConfirmationModule)
  },
  {
    path: 'share/key/:value',
    loadChildren: () => import('../share-redirect/share-redirect.module').then(m => m.ShareRedirectModule)
  },
  {
    path: ':shopUid/:shoplistUid',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.SHOP_LIST_BUNDLE },
    loadChildren: () => import('../shoplist-detail/shoplist-detail.module').then(m => m.ShoplistDetailModule)
  },
  {
    path: ':shopUid',
    canActivate: [StyleLoadGuard],
    data: { styleBundle: StyleBundle.SHOP_LANDING_BUNDLE },
    loadChildren: () => import('../shop-landing-page/shop-landing-page.module').then(m => m.ShopLandingPageModule)
  },
  {
    path: '_/no-content/regret',
    component: RegretPageComponent
  },
  {
    path: '**',
    redirectTo: '_/no-content/regret'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContentShellRoutingModule { }

